import { useNavigate } from "react-router-dom";
import { CardInfo, StatsHeader } from "../StatsHeader";
import { RoutePath } from "@src/interfaces";
import { useMemo, useState } from "react";
import { OutlinedCopyIcon, SuccessIcon } from "@src/assets";
import { Button, ButtonVariants } from "@src/components";
import { SWAPPER_FINANCE_URL } from "@src/config";

export const Invite = ({
  invitesUnlocked,
  headerData,
  referralCode,
}: {
  invitesUnlocked: boolean;
  referralCode: string;
  headerData: {
    invitedFriends: { curr: number; prev: number };
    points: {
      curr: number;
      prev: number;
    };
  };
}) => {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const { invitedFriends, points } = headerData;

  const statsCards: { leftCard: CardInfo; rightCard: CardInfo } = {
    leftCard: {
      title: "Invited friends",
      value: invitedFriends.curr,
      prevValue: invitedFriends.prev,
    },
    rightCard: {
      title: "Points from invites",
      value: points.curr,
      prevValue: points.prev,
    },
  };

  const inviteLink = useMemo(
    () =>
      referralCode ? `${SWAPPER_FINANCE_URL}?ref=${referralCode}` : undefined,
    [referralCode],
  );

  const onButtonClick = async () => {
    if (invitesUnlocked && inviteLink) {
      try {
        await navigator.clipboard.writeText(inviteLink);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (err) {
        console.error("Failed to copy invite link", err);
      }
    } else {
      navigate(RoutePath.Buy);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <StatsHeader cards={statsCards} />
      <p className="text-sm text-text_primary/60 text-center px-4">
        Earn 10% of the points your referrals make from their trading activity!
      </p>
      {!invitesUnlocked && (
        <p className="text-sm text-text_primary/60 text-center px-4">
          To be able to invite friends you have to complete your first trade
        </p>
      )}
      <Button
        variant={ButtonVariants.Primary}
        onClick={onButtonClick}
        disabled={copied || !inviteLink}
        icon={
          invitesUnlocked &&
          (copied ? (
            <SuccessIcon className="w-4 h-4 !fill-button_text_primary_disabled/70" />
          ) : (
            <OutlinedCopyIcon className="w-4 h-4 !fill-button_text_primary" />
          ))
        }
      >
        {invitesUnlocked ? (copied ? "Copied!" : "Copy invite link") : "Trade"}
      </Button>
    </div>
  );
};
